import { get, post, put, patch } from "../Config"

export function SearchHighlight({ params = {}, lang }) {
  return get({ url: `/v1/admin/highlight`, params, lang })
}
export function GetHighlightById({ id, lang }) {
  return get({ url: `/v1/admin/highlight/${id}`, lang })
}
export function CreateHighlight({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/highlight`, params, data, lang })
}
export function UpdateHighlight({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/highlight/${id}`, params, data, lang })
}
export function PatchHighlight({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/highlight/${id}`, params, data, lang })
}
export function DeleteHighlight({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/highlight/mutiDelete`, params, data, lang })
}
